import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { LayoutHeader } from "@/Header";
import { useMemberCode } from "~/services/customer/myPage";

export const Route = createFileRoute("/customer/layout/member-code")({
  component: MemberCodePage,
});

/** QR 페이로드 — 회원코드만 담는다(펫은 매장에서 선택). MTKT: 접두어로 스캐너가 구분. */
const buildQrPayload = (memberCode: string) => `MTKT:${memberCode}`;

function MemberCodePage() {
  const { data, isLoading } = useMemberCode();
  const [copied, setCopied] = useState(false);

  const memberCode = data?.memberCode ?? "";
  const userName = data?.userName ?? "";

  const copyCode = async () => {
    if (!memberCode) return;
    try {
      await navigator.clipboard.writeText(memberCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard 미지원 무시 */
    }
  };

  return (
    <>
      <LayoutHeader title="MY코드" hasBackBtn hasFootPrint={false} />
      <div className="flex flex-col flex-auto bg-[#F5F5F5]">
        <div className="flex flex-col flex-auto gap-4 px-5 pt-4 pb-10">
          <p className="text-[13px] leading-relaxed text-[#666]">
            매장에서 <b className="text-[#FF9934]">이용권 발급·체크인·본인확인</b> 등이 필요할 때
            아래 <b className="text-[#FF9934]">QR 또는 회원코드</b>를 보여주세요.
          </p>

          <div className="flex flex-col items-center gap-4 rounded-2xl bg-white px-5 py-8 shadow-sm">
            {isLoading ? (
              <div className="py-16 text-[14px] text-[#999]">불러오는 중…</div>
            ) : !memberCode ? (
              <div className="py-16 text-[14px] text-[#999]">회원코드를 불러오지 못했어요.</div>
            ) : (
              <>
                {userName && (
                  <div className="text-[15px] font-bold text-[#111]">{userName} 님</div>
                )}
                <div className="rounded-xl border border-[#EEE] bg-white p-3">
                  <QRCodeSVG value={buildQrPayload(memberCode)} size={200} level="M" includeMargin />
                </div>
                <div className="w-full">
                  <div className="text-center text-[12px] text-[#999]">회원코드</div>
                  <div className="mt-1 flex items-center justify-center gap-2">
                    <span className="font-mono text-[32px] font-extrabold tracking-[0.18em] text-[#111]">
                      {memberCode}
                    </span>
                    <button
                      type="button"
                      onClick={copyCode}
                      className="rounded-lg border border-[#E0E0E0] px-3 py-1.5 text-[12px] font-medium text-[#555] active:bg-[#F5F5F5]"
                    >
                      {copied ? "복사됨" : "복사"}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          <p className="text-center text-[12px] leading-relaxed text-[#AAA]">
            이 코드는 회원 본인 확인용이니 함부로 공유하지 마세요.
          </p>
        </div>
      </div>
    </>
  );
}
